/** @format */

import React, { Fragment, useContext, useEffect, useMemo, memo } from 'react';
import { animated } from 'react-spring';
import { __RouterContext } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import i18n from '../../i18n';
import installImage from '../../../images/img/install_app.svg';

import iosImage from '../../../images/appdownload/ios_image.png';
import androidImage from '../../../images/appdownload/android_image.png';
import qrcodeImage from '../../../images/appdownload/qr_code.png';

import logo from '../../../images/img/app_icon.png';
import '../Download/Download.module.scss';

const calc = (x, y) => [x - window.innerWidth / 2, y - window.innerHeight / 2];
const trans1 = (x, y) => `translate3d(${x / 10}px,${y / 10}px,0)`;

const baseUrl = `/${i18n.language}`.toLowerCase();

export default (props) => {
	return (
		<div>
			<div>
				<div class="centerall">
					<section class="section is-medium">
						<div class="container is-fluid">
							<div class="columns is-vcentered ">
								<div class="column">
									<div class="content">
										<h1
											class="title is-2"
											style={{ marginLeft: 10, marginRight: 10 }}>
											台灣最大實體聚會社交平台 - App Store五度推薦
										</h1>
									</div>
									<div class="content">
										<div>
											<p
												class="subtitle is-5"
												style={{ marginLeft: 10, marginRight: 10 }}>
												無論你想線上配對，或直接約碰面，Eatgether都可以滿足你！約會、洽商、唱歌、爬山、看電影甚至各種活動，都可在Eatgether上找到！累積超過100萬場聚會，每2分鐘就有一個新活動，約碰面成功率高達60%的最大實體聚會平台。
												<br />
												<br />◆ 蘋果App store五度推薦，內容嚴格把關保證100%真人會員
												<br />◆ 線上配對系統，配對成功免加值即可聊天
												<br />◆ 首創即時約會系統，馬上約馬上走
												<br />◆ 首創評價機制，約會看評價免踩雷
												<br />◆ 社群功能導入，撰寫貼文分享心情或追蹤好友動態
												<br />◆ 點數功能導入，點讚貼文即為贊助，累積贊助可換取禮物
												<br />◆ 新手專屬福利：新手期間多項功能免加值不受限
											</p>
										</div>
										<div style={{ marginLeft: 10, marginRight: 10 ,marginTop: 14, marginBottom: 14}}>
											<a href="https://play.google.com/store/apps/details?id=com.eatme.eatgether&hl=zh-TW">
												<img src={androidImage} width = "140" />
											</a>
											<a href="https://apps.apple.com/tw/app/id1121788143">
												<img src={iosImage} width = "140" style={{marginLeft:10}}/>
											</a>
										</div>
										<div>
											<img src="https://cdn.eatgether.com/images/website/download_code.png" width = "160"/>
										</div>
									</div>
								</div>

								<animated.div class="column has-text-centered has-text-centered is-hidden-mobile">
									<img src={installImage} style={{ maxWidth: 400 }} />
								</animated.div>
							</div>
						</div>
					</section>
				</div>
			</div>
		</div>
	);
};
